/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetTradingChallengeByIDOptions,
  GetTradingChallengeByIDStatus200,
  GetTradingChallengeByIDStatus400,
  GetTradingChallengeByIDStatus403,
  GetTradingChallengeByIDStatus404,
  GetTradingChallengeByIDStatus500,
} from '../types/GetTradingChallengeByID'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getTradingChallengeByID } from '../clients/getTradingChallengeByID'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getTradingChallengeByIDQueryKey = ({
  path,
}: Omit<GetTradingChallengeByIDOptions, 'headers'>) =>
  [{ url: '/v1/trading_challenges/:trading_challenge_id', params: path }] as const

type GetTradingChallengeByIDQueryKey = ReturnType<typeof getTradingChallengeByIDQueryKey>

export function getTradingChallengeByIDQueryOptions(
  { path }: GetTradingChallengeByIDOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getTradingChallengeByIDQueryKey({ path })
  return queryOptions<
    GetTradingChallengeByIDStatus200,
    ResponseErrorConfig<
      | GetTradingChallengeByIDStatus400
      | GetTradingChallengeByIDStatus403
      | GetTradingChallengeByIDStatus404
      | GetTradingChallengeByIDStatus500
    >,
    GetTradingChallengeByIDStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTradingChallengeByID({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Fetch one trading challenge. COMPETITION_MANAGER can access only assigned challenge IDs.
 * @summary Get trading challenge by ID
 * {@link /v1/trading_challenges/:trading_challenge_id}
 */
export function useGetTradingChallengeByID<
  TData = GetTradingChallengeByIDStatus200,
  TQueryData = GetTradingChallengeByIDStatus200,
  TQueryKey extends QueryKey = GetTradingChallengeByIDQueryKey,
>(
  {
    path,
  }: {
    path: GetTradingChallengeByIDOptions['path'] | (() => GetTradingChallengeByIDOptions['path'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTradingChallengeByIDStatus200,
        ResponseErrorConfig<
          | GetTradingChallengeByIDStatus400
          | GetTradingChallengeByIDStatus403
          | GetTradingChallengeByIDStatus404
          | GetTradingChallengeByIDStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getTradingChallengeByIDQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getTradingChallengeByIDQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetTradingChallengeByIDStatus400
      | GetTradingChallengeByIDStatus403
      | GetTradingChallengeByIDStatus404
      | GetTradingChallengeByIDStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
